"use strict";
import {gsap} from "gsap";
import {ScrollTrigger} from "gsap/ScrollTrigger";

let imagesLoaded = require('imagesloaded');
import Swiper from 'swiper';
import {Navigation, Pagination, EffectFade} from 'swiper/modules';

gsap.registerPlugin(ScrollTrigger);


document.addEventListener('DOMContentLoaded', function () {
    console.log('Init Scripts');

    // menu
    const menuBtn = document.getElementById('menu-burger');
    const b1 = document.querySelector('#menu-burger .b1');
    const b2 = document.querySelector('#menu-burger .b2');
    const overlay = document.getElementById('menu-overlay');
    const menuItems = gsap.utils.toArray('.menuItems a');
    const sMenuBtn = gsap.utils.toArray('.menuItems .has-submenu-arrow .nav-link');
    const sMenuBtn2 = gsap.utils.toArray('.menuItems .has-submenu');
    let nav = document.querySelector(".navbar");
    let scrollTop = document.getElementById("scroll-top");
    let mm = gsap.matchMedia();
    let menuOpen = false;
    let navTl = null;
    const breakPoint = 1199;
    let isMobileG = false;
    mm.add({
        isDesktop: `(min-width: ${breakPoint}px)`,
        isMobile: `(max-width: ${breakPoint}px)`,
    }, (context) => {
        let {isDesktop, isMobile} = context.conditions;
        // hide overlay
        gsap.set(overlay, {
            marginTop: isMobile ? "-100vh" : 0
        })

        isMobileG = !!isMobile;
        // set menuItems
        gsap.set(menuItems, {
            opacity: isMobile ? 0 : 1
        })

        // overlay timeline
        navTl = gsap.timeline({
            defaults: {
                ease: 'power4.inOut',
                repeatRefresh: true,
            }
        });

        navTl
            .to(b1, {
                y: '-=5',
                duration: 0.2
            })
            .to(b2, {
                y: '+=5',
                duration: 0.2
            }, "-=0.2")
            .to(b1, {
                rotation: 45,
                transformOrigin: '50% 50%',
                duration: 0.3
            })
            .to(b2, {
                rotation: -45,
                transformOrigin: '50% 50%',
                duration: 0.3
            }, "-=0.3")
            .to(overlay, {
                marginTop: 0,
                duration: 0.5
            }, "-=0.5")
            .to(menuItems, {
                opacity: 1,
                stagger: 0.05,
                duration: 0.5
            }, "-=0.2")
        navTl.pause();
    })

    // toggle menu

    const closeMenu = () => {
        navTl.reverse();
        menuOpen = false;
        // close submenu in mobile if open
        if (isMobileG) {
            [].forEach.call(sMenuBtn, function (btn) {
                btn.classList.remove('open');
            });
        }
    }

    menuBtn.addEventListener('click', (evt) => {
        evt.preventDefault();
        if (!menuOpen) {
            navTl.play();
            menuOpen = true;
        } else {
            closeMenu();
        }
    })

    // close the overlay when a menu link is tapped in mobile
    // (one-page anchors scroll within the page, so nothing would close it otherwise)
    menuItems.forEach(function (link) {
        // submenu toggles only open/close their own submenu
        if (sMenuBtn.indexOf(link) !== -1) {
            return;
        }
        link.addEventListener('click', () => {
            if (isMobileG && menuOpen) {
                closeMenu();
            }
        });
    });


    if (isMobileG) {
        [].forEach.call(sMenuBtn, function (btn) {
            btn.parentNode.querySelector('.back-sub').addEventListener('click', (evt) => {
                console.log(btn)
                btn.parentNode.classList.remove('open')
            })
            btn.addEventListener('click', (evt) => {
                evt.preventDefault();
                if (btn.parentNode.classList.contains('open')) {
                    btn.parentNode.classList.remove('open')
                } else {
                    btn.parentNode.classList.add('open')
                }
            })
        })
    } else {
        [].forEach.call(sMenuBtn2, function (btn) {
            btn.addEventListener('mouseenter', (evt) => {
                nav.classList.add('sub-active')
            })
            btn.addEventListener('mouseleave', (evt) => {
                nav.classList.remove('sub-active')
            })
        });
    }


    // open all external links in new tab
    const allLinks = document.querySelectorAll('a[href^="http://"], a[href^="https://"]');
    allLinks.forEach(link => {
        const currentDomain = window.location.hostname;
        const linkDomain = new URL(link.href).hostname;
        if (linkDomain !== currentDomain) {
            link.setAttribute('target', '_blank');
            link.setAttribute('rel', 'noopener noreferrer');
        }
    });


    if (document.querySelector('.matter-box')) {
        initLabels()
    }

    imagesLoaded(document.querySelector("main"), function (instance) {
        const stl = gsap.timeline();
        stl.to('.loader', {opacity: 0, duration: 0.3}, '-=0');
        stl.to('.navbar', {opacity: 1, duration: 0.6}, '-=0');
        stl.to('main', {opacity: 1, duration: 0.6}, '-=0.3');
        stl.to('footer', {opacity: 1, duration: 0.6}, '-=0');

        /*    if(document.querySelector(".hero")) {
                const tl = gsap.timeline({
                    scrollTrigger: {
                        trigger: ".hero",
                        start: "top top",
                        end: "bottom top",
                        scrub: true
                    }
                });

                gsap.utils.toArray(".parallax").forEach(layer => {
                    const depth = layer.dataset.depth;
                    const movement = -(layer.offsetHeight * depth)
                    tl.to(layer, {y: movement, ease: "none"}, 0)
                });
            }
    */


        // swiper
        const swiper = new Swiper('.impressionSwiper', {
            modules: [Navigation, Pagination, EffectFade],
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
            effect: 'fade',
            // To avoid overlapping issues, especially with autoplay
            fadeEffect: {
                crossFade: true,
            },
            // Optional parameters
            direction: 'horizontal',
            loop: true,
            slidesPerView: 1,
            spaceBetween: 0,
        });

        // accordion
        const accordionGroups = document.querySelectorAll('.accordion-group');
        accordionGroups.forEach(group => {
            group.addEventListener('click', function () {
                this.classList.toggle('expanded');
            });
        });


    })


});


function initLabels() {
    // module aliases
    let Engine = Matter.Engine,
        Render = Matter.Render,
        Runner = Matter.Runner,
        Bodies = Matter.Bodies,
        Composite = Matter.Composite,
        MouseConstraint = Matter.MouseConstraint,
        Mouse = Matter.Mouse,
        Events = Matter.Events,
        Body = Matter.Body;

    // create an engine
    let engine = Engine.create();

    // select the element where you want to render the simulation
    let matterBox = document.querySelector('.matter-box');

    // create a renderer
    let render = Render.create({
        element: matterBox,
        engine: engine,
        options: {
            width: matterBox.clientWidth,
            height: matterBox.clientHeight,
            wireframes: false,
            background: 'transparent'
        }
    });

    let matterElems = document.querySelectorAll('.dm-matter-elem');

    // Function to create rectangles for dm-matter-elem elements
    function createRectangles() {
        return Array.from(matterElems).map(function (matterElem) {
            let elemWidth = matterElem.offsetWidth;
            let elemHeight = matterElem.offsetHeight;
            let elemPosX = 250 + Math.round(Math.random() * (matterBox.clientWidth - 500)) + elemWidth / 2;
            let elemPosY = 0 - Math.random() * 250;

            let elemBody = Bodies.rectangle(elemPosX, elemPosY, elemWidth, elemHeight, {
                density: 0.01,
                friction: 0.4,
                restitution: 0.2,
                render: {
                    opacity: 0
                }
            });


            setTimeout(function () {
                Composite.add(engine.world, elemBody);
            }, Math.random() * 1000
            )
            return elemBody;
        });
    }


    // create bodies for elements
    let elemBodies = createRectangles();

    // Function to create static bodies for boundaries
    function createBoundaries() {
        let ground = Bodies.rectangle(matterBox.clientWidth / 2, matterBox.clientHeight, matterBox.clientWidth, 1, {
            isStatic: true,
            render: {
                opacity: 0
            }
        });

        let leftWall = Bodies.rectangle(0, matterBox.clientHeight / 2, 1, matterBox.clientHeight, {
            isStatic: true,
            render: {
                opacity: 0
            }
        });

        let rightWall = Bodies.rectangle(matterBox.clientWidth, matterBox.clientHeight / 2, 1, matterBox.clientHeight, {
            isStatic: true,
            render: {
                opacity: 0
            }
        });

        let topWall = Bodies.rectangle(matterBox.clientWidth / 2, -300, matterBox.clientWidth, 1, {
            isStatic: true,
            render: {
                opacity: 0
            }
        });

        // add all of the bodies to the world
        Composite.add(engine.world, [ground, leftWall, rightWall, topWall]);
    }

    createBoundaries();

    // create runner
    let runner = Runner.create();

    // add mouse control
    let mouse = Mouse.create(render.canvas),
        mouseConstraint = MouseConstraint.create(engine, {
            mouse: mouse,
            constraint: {
                stiffness: 0.2,
                render: {
                    visible: false
                }
            }
        });

    Composite.add(engine.world, mouseConstraint);

    // keep the mouse in sync with rendering
    render.mouse = mouse;

    // update positions and rotations after every engine update
    Events.on(engine, 'afterUpdate', function () {
        elemBodies.forEach(function (elemBody, index) {
            let angle = elemBody.angle;
            let position = elemBody.position;
            let matterElem = matterElems[index];

            matterElem.style.left = (position.x - matterElem.offsetWidth / 2) + 'px';
            matterElem.style.top = (position.y - matterElem.offsetHeight / 2) + 'px';
            matterElem.style.transform = 'rotate(' + angle + 'rad)';
        });
    });

    // Function to handle resize event
    function handleResize() {
        // Clear the existing bodies
        Composite.clear(engine.world, false);

        // Recreate boundaries and bodies
        createBoundaries();
        elemBodies = createRectangles();

        // Update the renderer size
        render.options.width = matterBox.clientWidth;
        render.options.height = matterBox.clientHeight;

        // Update mouse constraint
        mouseConstraint.mouse.element.removeEventListener("mousewheel", mouseConstraint.mouse.mousewheel);
        mouseConstraint.mouse.element.removeEventListener("DOMMouseScroll", mouseConstraint.mouse.mousewheel);

        mouseConstraint.mouse.element.removeEventListener('touchstart', mouseConstraint.mouse.mousedown);
        mouseConstraint.mouse.element.removeEventListener('touchmove', mouseConstraint.mouse.mousemove);
        mouseConstraint.mouse.element.removeEventListener('touchend', mouseConstraint.mouse.mouseup);

        mouseConstraint.mouse.element.addEventListener('touchstart', mouseConstraint.mouse.mousedown, {passive: true});
        mouseConstraint.mouse.element.addEventListener('touchmove', (e) => {
            if (mouseConstraint.body) {
                mouseConstraint.mouse.mousemove(e);
            }
        });
        mouseConstraint.mouse.element.addEventListener('touchend', (e) => {
            if (mouseConstraint.body) {
                mouseConstraint.mouse.mouseup(e);
            }
        });
    }

    // Add resize event listener
    window.addEventListener('resize', handleResize);

    // Allow scrolling when mouse is on matter container
    mouseConstraint.mouse.element.removeEventListener("mousewheel", mouseConstraint.mouse.mousewheel);
    mouseConstraint.mouse.element.removeEventListener("DOMMouseScroll", mouseConstraint.mouse.mousewheel);

    // Allow swiping on touch-screen when in touch with the matter container
    mouseConstraint.mouse.element.removeEventListener('touchstart', mouseConstraint.mouse.mousedown);
    mouseConstraint.mouse.element.removeEventListener('touchmove', mouseConstraint.mouse.mousemove);
    mouseConstraint.mouse.element.removeEventListener('touchend', mouseConstraint.mouse.mouseup);

    mouseConstraint.mouse.element.addEventListener('touchstart', mouseConstraint.mouse.mousedown, {passive: true});
    mouseConstraint.mouse.element.addEventListener('touchmove', (e) => {
        if (mouseConstraint.body) {
            mouseConstraint.mouse.mousemove(e);
        }
    });
    mouseConstraint.mouse.element.addEventListener('touchend', (e) => {
        if (mouseConstraint.body) {
            mouseConstraint.mouse.mouseup(e);
        }
    });

    // Flag to check if the engine has started
    let engineStarted = false;

    // Intersection Observer to start the engine only once
    let observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
            if (entry.isIntersecting && !engineStarted) {
                // Element is in viewport and engine has not started yet
                engineStarted = true;
                Runner.run(runner, engine);
                Render.run(render);
            }
        });
    }, {
        threshold: 0.1 // Adjust the threshold as needed
    });

    // Start observing the matterBox
    observer.observe(matterBox);
}

